import { useMemo } from "react";
import { useDemoUsers } from "@/hooks/common/useDemoUsers";
import { useDemoOrgData } from "@/hooks/organization/useDemoOrgData";
import type { ActorAvatarLookup } from "@/views/inbox/lib/utils";

export function useActorAvatarLookup(): ActorAvatarLookup {
  const { profilePictures, userIds } = useDemoUsers();
  const { userProfile } = useDemoOrgData();

  return useMemo<ActorAvatarLookup>(
    () => ({
      You: userProfile.profileImage,
      "Demo User": userProfile.profileImage,
      "Adam Silver": profilePictures[userIds.ADAM_SILVER],
      "Roger Goodell": profilePictures[userIds.ROGER_GOODELL],
    }),
    [profilePictures, userIds, userProfile],
  );
}
